module.exports = __webpack_public_path__ + "img/ice-hockey.b8995e9d.png";